// JWT token işlemleri için yardımcı fonksiyonlar
import { User } from '../types/auth';

/**
 * Local storage ve session storage'dan JWT token'ı alır
 * @returns {string|null} JWT token veya null
 */
export const getAuthToken = (): string | null => {
  // Önce localStorage'dan kontrol et, yoksa sessionStorage'dan kontrol et
  return localStorage.getItem('accessToken') || 
         localStorage.getItem('token') || 
         sessionStorage.getItem('accessToken') || 
         sessionStorage.getItem('token');
};

/**
 * JWT token'ı local storage'a kaydeder
 * @param {string} token - JWT token
 */
export const setAuthToken = (token: string): void => {
  localStorage.setItem('accessToken', token);
  localStorage.setItem('token', token);
};

/**
 * Local storage ve session storage'dan JWT token'ı siler
 */
export const removeAuthToken = (): void => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('token');
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('token');
};

/**
 * Token'ın geçerli olup olmadığını kontrol eder
 * @returns {boolean} Token geçerli mi
 */
export const isTokenValid = (): boolean => {
  const token = getAuthToken();
  if (!token) return false;
  
  try {
    // Token'ın süresi dolmuş mu kontrol et
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expiry = payload.exp * 1000; // milisaniyeye çevir
    return Date.now() < expiry;
  } catch (error) {
    console.error('Token doğrulanamadı:', error);
    return false;
  }
};

/**
 * JWT token'dan kullanıcı bilgilerini alır
 * @returns {User|null} Kullanıcı bilgileri veya null
 */
export const getUser = (): User | null => {
  const token = getAuthToken();
  if (!token) return null;
  
  try {
    // Token'dan kullanıcı bilgilerini çıkar
    const payload = JSON.parse(atob(token.split('.')[1]));
    // Rolleri diziye ve lowercase'e normalize et
    const rawRoles = payload.role ?? payload.roles ?? [];
    const rolesArray: string[] = Array.isArray(rawRoles)
      ? rawRoles
      : (typeof rawRoles === 'string' && rawRoles.length > 0 ? [rawRoles] : []);
    const normalizedRoles = rolesArray.map(r => String(r).toLowerCase());

    return {
      id: payload.nameid || payload.sub,
      userName: payload.unique_name || payload.name,
      email: payload.email,
      roles: normalizedRoles
    };
  } catch (error) {
    console.error('Kullanıcı bilgileri alınamadı:', error);
    return null;
  }
};
